
import { Component, inject, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { PartService } from '../../parts/shared/part.service';
import { IPartGroup } from '../../parts/shared/models';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/**
 * @TODO: Integrate MatFormFieldControl with submit
 *        event so it marked as touched [3].
 */
@Component({
    selector: 'app-select-part-group-control',
    imports: [
    MatSelectModule
],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectPartGroupControlComponent
        }
    ],
    templateUrl: './select-part-group-control.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './select-part-group-control.component.scss'
})
export class SelectPartGroupControlComponent implements ControlValueAccessor, OnInit {
  protected service: PartService = inject(PartService);
  private disabled: boolean = false;
  @Input() label: string = '';

  @ViewChild('partGroupSelect', {static: true}) partGroupSelect!: MatSelect;

  partGroups!: IPartGroup[];

  ngOnInit() {
    this.service.getPartGroups().subscribe((groups) => {
      this.partGroups = groups;
    });

    this.partGroupSelect.selectionChange.subscribe(val => {
      this.onChange(val.value);
    });
  }

  onChange: (newvalue: string) => void = (value) => {};
  onTouched: () => void = () => {};

  writeValue(obj: any): void {
      this.partGroupSelect.writeValue(obj);
  }

  registerOnChange(fn: any): void {
      this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
      this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
      this.disabled = isDisabled;
  }
}
